<template>
  <section class="pricing py-5">
    <div class="container">
      <div class="row">
        <!-- Free Tier -->
        <div class="col-lg-4">
          <div class="card mb-5 mb-lg-0">
            <div class="card-body">
              <h5 class="card-title text-muted text-uppercase text-center">Basic</h5>
              <h6 class="card-price text-center">€0<span class="period">/day</span></h6>
              <hr>
              <ul class="fa-ul">
                <li><span class="fa-li"><i class="fas fa-check"></i></span>Single User</li>
                <li><span class="fa-li"><i class="fas fa-check"></i></span>5GB Storage</li>
                <li><span class="fa-li"><i class="fas fa-check"></i></span>Unlimited Public Projects</li>
                <li><span class="fa-li"><i class="fas fa-check"></i></span>Community Access</li>
                <li class="text-muted"><span class="fa-li"><i class="fas fa-times"></i></span>Unlimited
                  Private Projects</li>
                <li class="text-muted"><span class="fa-li"><i class="fas fa-times"></i></span>Dedicated
                  Phone Support</li>
                <li class="text-muted"><span class="fa-li"><i class="fas fa-times"></i></span>Free Subdomain
                </li>
                <li class="text-muted"><span class="fa-li"><i class="fas fa-times"></i></span>Monthly Status
                  Reports</li>
              </ul>
              <div class="d-grid">
<!--                <a href="#" class="btn btn-primary text-uppercase">Button</a>-->
                <form action="https://www.coinpayments.net/index.php" method="post" target="_top">
                  <input type="hidden" name="cmd" value="_pay_simple">
                  <input type="hidden" name="reset" value="1">
                  <input type="hidden" name="merchant" value="11855d8e483f79a10c14a884b62796af">
                  <input type="hidden" name="currency" value="USDC">
                  <input type="hidden" name="amountf" value="5">
                  <input type="hidden" name="item_name" value="Test Item">
                  <input type="image" src="https://www.coinpayments.net/images/pub/buynow-wide-yellow.png" alt="Buy Now with CoinPayments.net">
                </form>
                <form action="https://secure.tpay.com/" method="post" name="payment">
                  <input name="kwota" value="1" type="hidden">
                  <input name="opis" value="test" type="hidden">
                  <input name="jezyk" value="PL" type="hidden">
                  <input name="id" value="63714" type="hidden">
                  <input name="md5sum" value="c29b8b588501dd1457deb9b8f650ca15" type="hidden">
<!--                  <input type="submit" value="Zapłać">-->
                  <input type="image" style="background: white; position: relative; width: 12em" src="https://c.smartrecruiters.com/sr-company-logo-prod-dc5/5d2db837339e866c0dcd58af/huge?r=s3-eu-central-1&_1590152216066">
                </form>
              </div>
            </div>
          </div>
        </div>
        <!-- Plus Tier -->
        <div class="col-lg-4">
          <div class="card mb-5 mb-lg-0">
            <div class="card-body">
              <h5 class="card-title text-muted text-uppercase text-center">Plus</h5>
              <h6 class="card-price text-center">€9<span class="period">/day</span></h6>
              <hr>
              <ul class="fa-ul">
                <li><span class="fa-li"><i class="fas fa-check"></i></span><strong>5 Users</strong></li>
                <li><span class="fa-li"><i class="fas fa-check"></i></span>50GB Storage</li>
                <li><span class="fa-li"><i class="fas fa-check"></i></span>Unlimited Public Projects</li>
                <li><span class="fa-li"><i class="fas fa-check"></i></span>Community Access</li>
                <li><span class="fa-li"><i class="fas fa-check"></i></span>Unlimited Private Projects</li>
                <li><span class="fa-li"><i class="fas fa-check"></i></span>Dedicated Phone Support</li>
                <li><span class="fa-li"><i class="fas fa-check"></i></span>Free Subdomain</li>
                <li class="text-muted"><span class="fa-li"><i class="fas fa-times"></i></span>Monthly Status
                  Reports</li>
              </ul>
              <div class="d-grid">
                <form action="https://www.coinpayments.net/index.php" method="post" target="_top">
                  <input type="hidden" name="cmd" value="_pay_simple">
                  <input type="hidden" name="reset" value="1">
                  <input type="hidden" name="merchant" value="11855d8e483f79a10c14a884b62796af">
                  <input type="hidden" name="currency" value="USDC">
                  <input type="hidden" name="amountf" value="5">
                  <input type="hidden" name="item_name" value="Test Item">
                  <input type="image" src="https://www.coinpayments.net/images/pub/buynow-wide-yellow.png" alt="Buy Now with CoinPayments.net">
                </form>
              </div>
            </div>
          </div>
        </div>
        <!-- Pro Tier -->
        <div class="col-lg-4">
          <div class="card">
            <div class="card-body">
              <h5 class="card-title text-muted text-uppercase text-center">Pro</h5>
              <h6 class="card-price text-center">€49<span class="period">/day</span></h6>
              <hr>
              <ul class="fa-ul">
                <li><span class="fa-li"><i class="fas fa-check"></i></span><strong>Unlimited Users</strong>
                </li>
                <li><span class="fa-li"><i class="fas fa-check"></i></span>150GB Storage</li>
                <li><span class="fa-li"><i class="fas fa-check"></i></span>Unlimited Public Projects</li>
                <li><span class="fa-li"><i class="fas fa-check"></i></span>Community Access</li>
                <li><span class="fa-li"><i class="fas fa-check"></i></span>Unlimited Private Projects</li>
                <li><span class="fa-li"><i class="fas fa-check"></i></span>Dedicated Phone Support</li>
                <li><span class="fa-li"><i class="fas fa-check"></i></span><strong>Unlimited</strong> Free
                  Subdomains</li>
                <li><span class="fa-li"><i class="fas fa-check"></i></span>Monthly Status Reports</li>
              </ul>
              <div class="d-grid">
                <form action="https://www.coinpayments.net/index.php" method="post" target="_top">
                  <input type="hidden" name="cmd" value="_pay_simple">
                  <input type="hidden" name="reset" value="1">
                  <input type="hidden" name="merchant" value="11855d8e483f79a10c14a884b62796af">
                  <input type="hidden" name="currency" value="USDC">
                  <input type="hidden" name="amountf" value="5">
                  <input type="hidden" name="item_name" value="Test Item">
                  <input type="image" src="https://www.coinpayments.net/images/pub/buynow-wide-yellow.png" alt="Buy Now with CoinPayments.net">
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "TierPage"
}
</script>

<style scoped>
section.pricing {
  background: #007bff;
  /*background: linear-gradient(to right, #0062E6, #33AEFF);*/
  background: transparent;
}

.pricing .card {
  border: none;
  border-radius: 1rem;
  transition: all 0.2s;
  box-shadow: 0 0.5rem 1rem 0 rgba(0, 0, 0, 0.1);
}

.pricing hr {
  margin: 1.5rem 0;
}

.pricing .card-title {
  margin: 0.5rem 0;
  font-size: 0.9rem;
  letter-spacing: .1rem;
  font-weight: bold;
}

.pricing .card-price {
  font-size: 3rem;
  margin: 0;
}

.pricing .card-price .period {
  font-size: 0.8rem;
}

.pricing ul li {
  margin-bottom: 1rem;
}

.pricing .text-muted {
  opacity: 0.7;
}

.pricing .btn {
  font-size: 80%;
  border-radius: 5rem;
  letter-spacing: .1rem;
  font-weight: bold;
  padding: 1rem;
  opacity: 0.7;
  transition: all 0.2s;
}

/* Hover Effects on Card */

@media (min-width: 992px) {
  .pricing .card:hover {
    margin-top: -.25rem;
    margin-bottom: .25rem;
    box-shadow: 0 0.5rem 1rem 0 rgba(0, 0, 0, 0.3);
  }

  .pricing .card:hover .btn {
    opacity: 1;
  }
}
</style>
